import { useDispatch, useSelector } from "react-redux";
import { select } from "application/store";
import { createContext, useContext, useEffect } from "react";
import { service } from "infrastructure";

const UnSignedDocumentsContext = createContext({ docs: [] });

export const UnSignedDocumentsProvider = ({ children }) => {
  const dispatch = useDispatch();

  const state = useSelector(
    select((models) => ({
      docs: models.unSignedDocs.docs,
      userInfo: models.auth.user,
      isAuthenticated: models.auth.isAuthenticated,
    }))
  );

  useEffect(() => {
    if (!state.isAuthenticated) return;

    if (!state.userInfo?.rut && !state.userInfo?.profile?.rut) {
      return;
    }

    if (state?.docs?.length <= 0) {
      dispatch.unSignedDocs.loadUnSignedDocuments(state.userInfo);
    }
  }, [state.isAuthenticated, state.userInfo]);

  return (
    <UnSignedDocumentsContext.Provider value={state}>
      {children}
    </UnSignedDocumentsContext.Provider>
  );
};

export const useSignDocuments = () => {
  const dispatch = useDispatch();
  const context = useContext(UnSignedDocumentsContext);

  if (context === undefined) {
    throw new Error(
      `useSignDocuments must be used inside a UnSignedDocumentsProvider`
    );
  }

  return {
    ...context,
    reload: () =>
      dispatch.unSignedDocs.loadUnSignedDocuments(context.userInfo.email),
    onDownloadDocuments: () =>
      service.downloadUnSignedDocuments(
        context.userInfo.email,
        context.userInfo.rut
      ),
  };
};
